export default function SelectInput({ className = '', value, options, onChange, ...props }) {

    return (
        <select
            {...props}
            value={value}
            className={`transition duration-500 ease-in-out transform border border-transparent rounded-lg focus:outline-none focus:border-transparent focus:ring-2 ${className}`}
            onChange={onChange}
            >
            <option value="">Please select an option</option>
            {options?.map((option, i) => {
                return (
                    <option key={i} value={option.value}>
                        {option.label}
                    </option>
                );
            })}
        </select>
    );
};
